<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <consultaprodutos v-bind:multiplo="true" v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa" :vidtabelapreco="vidtabelapreco"></consultaprodutos>
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-5 col-lg-5">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Situação:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="tpsituacao" @change="mtdlimpar_listagem()">
                                    <option value="" >Todos</option>
                                    <option value="0">Programadas</option>
                                    <option value="1">Ativas</option>
                                    <option value="2">Finalizadas</option>
                                    <option value="3">Canceladas</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstpromocoes"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item" >
                                        <div class="d-flex">
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)" title="Editar" ><i class="fa fa-edit"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)" title="Excluir" ><i class="fa fa-trash"></i></button>
                                            <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;"><i class="fa fa-navicon"></i></button>
                                        </div>
                                    </template>
                                    <template slot="descpromo" slot-scope="item" >
                                        <span style="color: #5A9564; font-weight: 700;">{{ formatavalores(parseFloat(item.row.descpromocional), 2) }}</span> 
                                    </template>
                                    <template slot="periodo" slot-scope="item">
                                        {{ item.row.dtinicio }} - {{ item.row.dtfim }}
                                    </template>
                                    <template slot="stpromocao_f" slot-scope="item">
                                        <span v-if="parseInt(item.row.stpromocao) == 0" class="badge badge-pill badge-info" style="background-color:#ff9800; font-size: 12px;">Programada</span>
                                        <span v-if="parseInt(item.row.stpromocao) == 1" class="badge badge-pill badge-success" style="background-color:#007bff; font-size: 12px;">Ativa</span>
                                        <span v-if="parseInt(item.row.stpromocao) == 2" class="badge badge-pill badge-success" style="background-color: #0acf97; font-size: 12px;">Finalizada</span>
                                        <span v-if="parseInt(item.row.stpromocao) == 3" class="badge badge-pill badge-danger" style=" font-size: 12px;">Cancelada</span>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstpromocoes.length}}</span>
                                    </li>
                                </ul>
                            </div>
                                        <!-- MODAIS -->

                            <!-- MODAL MENU -->
                            <div class="modal fade" id="mdlmenu">
                            <div class="modal-dialog modal-sm modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul class="list-group" style="cursor: pointer;">
                                                <li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ (itempromocao.id) }}</li>
                                                <button type="button" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdconfirmapromo(itempromocao)" title="Ativar promoção agora" ><i class="fa fa-check-circle"></i> ATIVAR PROMOÇÃO</button>
                                                <button type="button" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdcancelapromo(itempromocao)" title="Cancelar promoção" ><i class="fa fa-ban"></i> CANCELAR PROMOÇÃO</button>
                                                <button type="button" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdvisualizaprod(itempromocao)" title="Lista de produtos" ><i class="fa fa-file"></i> VISUALIZAR PRODUTOS</button>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer" style="padding: 5px;">
                                    <div class="container-fluid">
                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
                                            </div>
                                        </div>					
                                    </div>
                                </div>				        
                            </div>
                            </div>
                            </div>
                            <!-- VISU.PRODUTOS -->
                            <div class="modal fade modal-produtos" id="mdllstprod" >
                                <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                                    <div class="modal-content" style="height: 500px;">
                                        <div class="modal-header modal-header-custom">
                                            <h5 class="modal-title" ><i class="fa fa-tags" aria-hidden="true"></i> Produtos em Promoção</h5>
                                            <button type="button" class="close text-white" data-dismiss="modal">
                                            <span>&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body p-0" style="border-radius: 20px; height: 100%;">
                                            <div class="table-responsive">
                                            <table class="table table-bordered table-sm table-striped modal-tabela m-0">
                                                <thead>
                                                <tr style="font-weight: bold;">
                                                    <th class="caluna-cod">Cod.</th>                                                                 
                                                    <th style="width: 300px;">Descrição:</th>
                                                    <th class="">Pr. Custo</th>
                                                    <th class="">Pr. Venda</th>
                                                    <th class="">Vl. Promocional</th>
                                                    <th class="">Fator</th>
                                                    <th class="">Tipo</th>
                                                </tr>
                                                </thead>
                                                <tbody id="tbprodpromo">
                                                <template>
                                                    <tr v-for="(prodpromo, index) in produtosempromo" :key="index">
                                                        <td style="text-align: center;">{{ prodpromo.idproduto }}</td>
                                                        <td style="text-align: left;">{{ prodpromo.descricao }}</td>
                                                        <td style="text-align: end; ">{{ formatavalores(prodpromo.prcusto)}}</td>
                                                        <td style="text-align: end; ">{{ formatavalores(prodpromo.prvenda) }}</td>
                                                        <td v-if="prodpromo.tpdesconto == 0" style="text-align: end; font-weight: bolder;" :style="{color: parseFloat(prodpromo.prvenda) - (prodpromo.prvenda * parseFloat(prodpromo.descpromocional) / 100) <= 0 ? '#f82b54': '#28a745'}"> {{ prodpromo.descpromocional? formatavalores(parseFloat(prodpromo.prvenda) - (prodpromo.prvenda * parseFloat(prodpromo.descpromocional) / 100)) : '0,00' }} </td>
                                                        <td v-else style="text-align: end; font-weight: bolder;" :style="{color: prodpromo.prvenda - prodpromo.descpromocional <= 0 ? '#f82b54': '#28a745'}"> {{ prodpromo.descpromocional ? formatavalores(prodpromo.prvenda - prodpromo.descpromocional) : '0,00' }} </td>
                                                        <td style="text-align: end;">{{ formatavalores(prodpromo.descpromocional) }}</td>
                                                        <td style="text-align: end;">
                                                            <span v-if="prodpromo.tpdesconto == 1">Valor(R$)</span>
                                                            <span v-else>Percentual(%)</span>
                                                        </td>
                                                    </tr>
                                                </template>
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdimpressaoprodutospromo(produtosempromo)" style="width: 150px;"><i class="fa fa-download"></i> Imprimir</button>
                                            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="dtini">*De:</label>
                                    <div class="input-group">
                                        <date-picker id="dtini" v-model="vdtinicio" class="form-control form-control-sm" v-bind:disabled="ativadesativa" :config="options"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>								
                                    </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="dtfim">*Até:</label>
                                    <div class="input-group">
                                        <date-picker id="dtfim" v-model="vdtfim" class="form-control form-control-sm" v-bind:disabled="ativadesativa" :config="options2"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>																			
                                    </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">*Tabela:</span>
                                    <select id="cbtabelapreco" v-model="vidtabelapreco" v-bind:disabled="ativadesativa"
                                            data-placeholder="Selecione uma tabela" data-allow-clear="true" style="width:100%;">
                                    </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-3">
                                <div class="col-12">
                                    <label for="edvldescpromocional">*Desc. promocional em:</label>
                                </div>
                                <div class="col-12 d-flex">
                                    <select name="" id="" v-model="vtpdesconto" class="form-control form-control-sm mr-3"> 
                                        <option value= 0 >Percentual(%)</option>
                                        <option value= 1 >Valor(R$)</option>
                                    </select>
                                    <money type="text" class="form-control form-control-sm" id="edvldescpromocional"
                                        v-model="vdescpromocional" v-bind="money" v-bind:disabled="ativadesativa"
                                        data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                    </money>
                                </div>
                            </div>      
                        </div>
                        <div class="row">
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center">Selecione um produto</div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edidprodutoedicao">*Produto:</label>
                                                <div class="input-group">
                                                    <input type="text" class="form-control form-control-sm" id="edidprodutoedicao" v-model="vcoddigedicao"  v-on:blur="mtdlocalizarproduto(vcoddigedicao)" v-on:keyup.13="mtdlocalizarproduto(vcoddigedicao)" style="text-transform: uppercase;" v-bind:disabled="ativadesativa || habilitabuscaprod" >
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label for="edidprodutoedicao">Descrição:</label>
                                                <div class="input-group">
                                                    <input type="text" class="form-control form-control-sm" id="descprodutoedicao" v-model="vdescricaoprodutoedicao" style="text-transform: uppercase;" disabled>
                                                </div>
                                            </div>
                                            <div style="padding-top: 22px" class="col-sm-12 col-md-2 col-lg-2">
                                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdadicionaritem()" style="width: 100%;"><i class="fa fa-plus"></i> Incluir</button>
                                            </div>
                                        </div>
                                        <div class="row">
                                                <div class="table-responsive tbprod">
                                                    <table id="tblistaclasses" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-light">
                                                            <tr>
                                                                <th style="text-align: center;  max-width: 30px;">Ações:</th>
                                                                <th class="caluna-cod">Cod.</th>                                                                 
                                                                <th style="width: 500px;">Descrição:</th>
                                                                <th class="">Pr. Custo</th>
                                                                <th class="">Pr. Venda</th>
                                                                <th class="">Vl. Promocional</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="lstpromocao">
                                                            <template>
                                                                <tr v-for="(produto, index) in lstprodutos" v-bind:key="index">
                                                                    <td width="100" class="center" style="text-align: center;">
                                                                        <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                            v-bind:disabled="ativadesativa"
                                                                            @click.prevent="mtdexcluiritem(produto.idproduto)" title="Excluir" >
                                                                            <i class="fa fa-trash"></i>
                                                                        </a>                                                                        
                                                                    </td>                                                                                                                           
                                                                    <td :style="produto.stpromocao != null ? 'font-weight:bold;' : ''">{{ produto.idproduto }}</td>
                                                                    <td :style="produto.stpromocao != null ? 'font-weight:bold;' : ''">{{ produto.descricao }} <i class="fa fa-info-circle text-danger" v-show="produto.stpromocao != null" title="Produto já em promoção"></i></td>
                                                                    <td style="text-align: end; font-weight: bolder;">{{ formatavalores(produto.prcusto) }}</td>
                                                                    <td style="text-align: end; font-weight: bolder;">{{ formatavalores(produto.prvenda) }}</td>
                                                                    <td v-if="vtpdesconto == 0" style="text-align: end; font-weight: bolder;" :style="{color: parseFloat(produto.prvenda) - (produto.prvenda * parseFloat(vdescpromocional) / 100) <= 0 ? '#f82b54': '#28a745'}"> {{ vdescpromocional? formatavalores(parseFloat(produto.prvenda) - (produto.prvenda * parseFloat(vdescpromocional) / 100)) : '0,00' }} </td>
                                                                    <td v-else style="text-align: end; font-weight: bolder;" :style="{color: produto.prvenda - vdescpromocional <= 0 ? '#f82b54': '#28a745'}"> {{ vdescpromocional ? formatavalores(produto.prvenda - vdescpromocional) : '0,00' }} </td>
                                                                </tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-8">
                                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Os produtos em <span style="color: red;">destaque</span>  já estão vinculados a uma promoção vigente ou programada</strong>.</h5>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                                    <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import moment from 'moment'

    export default {
        name: 'cadpromocoes',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb,
            'consultaprodutos'  : ConsultarProdutos,
        },
        data: function() {
            return {
                //variaveis da consulta de produtos
				vshowprtabela			: false,//oculta a visualização do preço do produto na listagem
				vidtabela				: 1,//informo somente pq o componente exige
                tipopropesquisa         : '',

                vdescricaoprodutoedicao: '',

                lstpromocoes  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,
                tpsituacao : '',

                //variáveis do crud
                opcrud                    : 0,
                vid                       : '',
                vdescricao                : '',
                vdtinicio                 : util.DataAtual(true),
                vdtfim                    : util.DataAtual(true),
                vdescpromocional          : 0,
                stpromocao                : 0,
                lstprodutos               : [],
                listaProdutosSelecionados : [],
                itempromocao              : '',
                produtosempromo           : [],
                vtpdesconto               : 0,
                promocaoselecionada       : 0, 

                vcoddigedicao        : '',
                vidprodutoedicao     : '',
                
                money: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                options: {
                    format: 'DD/MM/YYYY',
                    useCurrent: false,
                    locale: 'pt-BR',
                    sideBySide: true,
                    minDate: moment().startOf('day'),
                },
                options2: {
                    format: 'DD/MM/YYYY',
                    useCurrent: false,
                    locale: 'pt-BR',
                    sideBySide: true,
                    minDate: moment().startOf('day')
                },
                vidtabelapreco      : null,

                //variável para habilitação dos campos
                ativadesativa       : true,

                // habilitabuscaprod : true,

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'PROMOÇÕES',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                        {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Desc. promocional",
                        name: "descpromo",
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        row_class: "def-col-descpromo"
                    },
                    {
                        label: "Período",
                        name: "periodo",
                        slot_name: "periodo",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_class: "def-col-stpromocao"
                    },
                    {
                        label: "Status",
                        name: "status",
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        slot_name: "stpromocao_f",
                        row_class: "def-col-stpromocao" 
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and tbprm.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(descricao) like upper("'+this.pconteudo+'%")';
                }
                if(this.tpsituacao != ''){
                    rfiltro = 'and stpromocao = ' + this.tpsituacao;
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpromocoes.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregapromocoes(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregapromocoes(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpromocoes.php');
                retorno.then(function (response) {
                    vself.lstpromocoes = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstpromocoes = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                = '';
                this.vdescricao         = '';
                this.vdtinicio          = util.DataAtual(true);
                this.vdtfim             = util.DataAtual(true);
                this.vidtabelapreco     = null;
                this.vdescpromocional   = 0,
                this.lstprodutos        = [];
                this.stpromocao         = 0;
                this.vcoddigedicao      = '';

                $('#cbtabelapreco').val(null).trigger('change');

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.070M.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE PROMOÇÕES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstpromocoes = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and tbprm.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpromocoes.php');
                retorno.then(function (response) {
                     loader.hide();
                     if(vself.opcrud > 0){
                        if(response.data[0].stpromocao > 0){
                            let mensagem = '';
                            let descop = '';
                            if(vself.opcrud == 2){
                                descop = 'alterar';
                            }
                            if(vself.opcrud == 3){
                                descop = 'excluir';
                            }
                            if(vself.opcrud >= 2){
                                if(response.data[0].stpromocao == 1){
                                    mensagem = "ativa";
                                } else if(response.data[0].stpromocao == 2){
                                    mensagem = "finalizada";
                                } else if(response.data[0].stpromocao == 3){
                                    mensagem = "cancelada";
                                }
                                vself.$toastr.i(`Não é possivel ${descop} uma promoção ${mensagem}!`, 'Informação!');
                                vself.mtdcancelaredicao();
                            }
                        }else{
                            vself.mtdigualarcampos(response.data[0]);
                            if (parseInt(vself.opcrud) < 3){
                                $('#eddescricao').focus();
                            }else{
                                $('#btgravar').focus();
                            }
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                let vself = this;

                if (!util.opcaousuario('002Z.070M.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE PROMOÇÕES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                let vself = this;
                let mensagem = '';

                if (!util.opcaousuario('002Z.070M.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE PROMOÇÕES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                 = registro.id;
                this.vdescricao          = registro.descricao;
                this.vdtinicio           = registro.dtinicio;
                this.vdtfim              = registro.dtfim;
                this.vdescpromocional    = registro.descpromocional;
                this.stpromocao          = registro.stpromocao;
                this.lstprodutos         = registro.produtos;

                var deftbprecos              = new Option(registro.destbpreco, registro.idtabelapreco, true, true);
                $('#cbtabelapreco').append(deftbprecos).trigger('change');  
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let idproduto = vself.lstprodutos.map(item => item.idproduto);


                let registrocrud = {
                    id                : vself.vid,
                    descricao         : vself.vdescricao,
                    dtinicio          : vself.vdtinicio,
                    dtfim             : vself.vdtfim,
                    idtabelapreco     : vself.vidtabelapreco,
                    descpromocional   : parseFloat(vself.vdescpromocional),
                    stpromocao        : vself.stpromocao,
                    produtos          : idproduto,
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'tpdesconto',   valor : vself.vtpdesconto},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.003Z.001Z' : parseInt(this.opcrud) === 2 ? '001Z.003Z.002Z' : '001Z.003Z.003Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpromocoes.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapromocoes(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdlocalizarproduto(coddig) {
                if (coddig !== '' && coddig !== null) {
                    let vself = this;
                    let loader = vself.$loading.show();
                    let filtro = ''
                    if(this.vidtabelapreco){
                        filtro = " AND tbpp.idtabela = "+ this.vidtabelapreco;
                    }

                    let parametros = [
                        { parametro: 'op',                  valor: 'listagemcomponente' },
                        { parametro: 'idclientesac',        valor: vself.$store.state.filialpadrao.idcliente },
                        { parametro: 'diretorioimagens',    valor: vself.$store.state.configpaths.pathimgprodutos + vself.$store.state.filialpadrao.idcliente },
                        { parametro: 'filtro',              valor: filtro },
                        { parametro: 'coddig',              valor: JSON.stringify(coddig) },
                        { parametro: 'idpromo',             valor: vself.vid},
                    ];

                    let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadprodutos.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if (response.data.length > 0) {
                            vself.listaProdutosSelecionados = response.data;
                            // console.log(vself.listaProdutosSelecionados);
                            // return;
                            // vself.vcoddigedicao = response.data.descricao;
                            let contagem = vself.listaProdutosSelecionados.length;
                            if(Number(contagem) < 2){
                                vself.vdescricaoprodutoedicao = vself.listaProdutosSelecionados[0].descricao;
                            }else{
                                vself.mtdadicionaritem();
                            }
                        } else {
                            vself.$toastr.w('Produto não vinculado a tabela selecionada!', 'Atenção!');
                            vself.mtdlimparedicaoitem();
                            $('#edidprodutoedicao').focus();
                        }
                    }).catch(function () {
                        loader.hide();
                    });
                }
            },
            mtdselect2_def(){
                let vself = this;

                $("#cbtabelapreco").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbtabelasprecos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidtabelapreco = $("#cbtabelapreco").val();
                });
            },
            mtdconsultarproduto(){
                if(this.vidtabelapreco == null){
                    this.$toastr.i('Selecione uma tabela de preço!', 'Informação!');
                    return
                }
				if (parseInt(this.opcrud) < 3){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},
            mtdadicionaritem() {
                let vself = this;
                // console.log("Lista prod sele:", vself.listaProdutosSelecionados);

                if (!Array.isArray(vself.listaProdutosSelecionados) || vself.listaProdutosSelecionados.length === 0) {
                    this.$toastr.i('Nenhum produto selecionado para adicionar!', 'Atenção!');
                    $('#edidprodutoedicao').focus();
                    return;
                }

                // let qtdeAdicionados = 0;

                let jaAdicionados = 0;

                vself.listaProdutosSelecionados.forEach(produto => {
                    if (!util.findValInArray(vself.lstprodutos, 'idproduto', produto.id)) {
                        let itemtmp = {
                            idproduto: produto.id,
                            descricao: produto.descricao,
                            prcusto: produto.prcusto,
                            prvenda: produto.prvendamedio,
                            stpromocao: produto.stpromocao,
                        };
                        vself.lstprodutos.push(itemtmp);
                        // console.log( 'aqui' , vself.lstprodutos);
                    } else {
                        jaAdicionados++;
                    }
                });

                if (jaAdicionados === vself.listaProdutosSelecionados.length) {
                    if (vself.listaProdutosSelecionados.length === 1) {
                        this.$toastr.w('O item selecionado já foi adicionado!', 'Atenção!');
                    } else {
                        this.$toastr.w('Todos os itens selecionados já foram adicionados!', 'Atenção!');
                    }
                }

                vself.vdescricaoprodutoedicao = "";
                vself.vcoddigedicao = "";
                setTimeout(() => {
                    $('#edidprodutoedicao').focus();
                }, 200);
            },
            mtdexcluiritem(item) {
                let indiceitem = this.lstprodutos.findIndex(prod => prod.idproduto === item);
                if (indiceitem > -1) {
                    this.lstprodutos.splice(indiceitem, 1);
                }
            },
            mtdpromocaoimediata(item){
                var vself       = this;
                // console.log(vself.stpromocao);
                // return;
                let parametros  = [
                    {parametro: 'op',           valor : 'promocaoimediata'},
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'registro',     valor : JSON.stringify(item)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpromocoes.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        $('#mdlmenu').modal('hide');
                        vself.mtdcarregapromocoes(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                $('#mdlmenu').modal('hide');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                $('#mdlmenu').modal('hide');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdcancelapromocao(item){
                var vself       = this;

                let parametros  = [
                    {parametro: 'op',           valor : 'cancelapromocao'},
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'registro',     valor : JSON.stringify(item)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpromocoes.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.mtdcarregapromocoes(1);
                        $('#mdlmenu').modal('hide');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                $('#mdlmenu').modal('hide');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                $('#mdlmenu').modal('hide');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            formatavalores:function (val) {
                return util.formatarvalor(val, '');
            },
            mtdconfirmapromo(item){
                let vself = this;

                if (!util.opcaousuario('002Z.070M.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }

                let mensagem = '';
                switch(Number(item.stpromocao)){
                    case 1:
                    mensagem = "que já está ativa";
                    break;
                    case 2:
                    mensagem = "finalizada";
                    break;
                    case 3:
                    mensagem = "cancelada";
                    break;
                }

                if(item.stpromocao > 0){
                    vself.$toastr.i('Não é possível ativar uma promoção '+ mensagem + '!', 'Informação!');
                    return;
                }

                $.confirm({
                    title: 'Confirmação!',
                    content: '<big>Deseja ativar a promoção imediatamente?</big>',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdpromocaoimediata(item);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdcancelapromo(item){
                let vself = this;

                if (!util.opcaousuario('002Z.070M.050Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }
                let mensagem = '';
                switch(Number(item.stpromocao)){
                    case 2:
                    mensagem = "finalizada";
                    break;
                    case 3:
                    mensagem = " que já está cancelada";
                    break;
                }
                
                if(item.stpromocao >= 2){
                    vself.$toastr.i(`Não é possível cancelar uma promoção ${mensagem}!`, 'Informação!');
                    return;
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: '<big>Cancelar promoção ativa?</big>',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-red',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdcancelapromocao(item);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdmostrarmenu(pedido){				
				this.itempromocao = pedido;
				$('#mdlmenu').modal('show');
			},
            mtdvisualizaprod(pedido){
                this.promocaoselecionada = pedido.id;
				this.produtosempromo = pedido.produtos;

				$('#mdllstprod').modal('show');
				$('#mdlmenu').modal('hide');
			},
            mtdimpressaoprodutospromo(){
                let vself = this;

                window.open(
                    vself.$store.state.configpaths.pathcontrole+'rtcadpromocoes.php?idclientesac='+
                                vself.$store.state.filialpadrao.idcliente+
                                '&op=imprimessaoprodutospromo'+
                                '&idpromocao='+vself.promocaoselecionada+
                                '&usuario='+vself.$store.state.usuario.nome, '_blank');
            },
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('001Z.003Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
                vself.mtdselect2_def();
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.vdtinicio == '' || this.vdtfim == '' || this.vidtabelapreco == null || this.vdescpromocional == 0 || this.lstprodutos == '';
            },
            habilitabuscaprod(){
                return this.vidtabelapreco == null;
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
            lstprodutosretorno(){
                return this.$store.state.listaprodutoretorno.lstprodutos;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregapromocoes(val);
            },
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddigedicao = val;
					this.mtdlocalizarproduto(this.vcoddigedicao);					
                }
			},
            lstprodutosretorno(val){
                if (val !== null || val !== ''){
					this.vcoddigedicao = val;
					this.mtdlocalizarproduto(this.vcoddigedicao);					
                }
			},
            vdtinicio(newVal) {
                if (newVal) {
                this.options2.minDate = moment(newVal, 'DD/MM/YYYY');
                } else {
                this.options2.minDate = moment().startOf('day');
                }
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-descpromo{
        text-align: end !important;
    }
    #btclonarperfilusuario{
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario:hover{
        color: #666666;
        transition: .35s;
    }

    #btmarcartodfiliais{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodfiliais:hover{
        color: #666666;
        transition: .35s;
    }
    #btclonarperfilusuario:hover{
        color: #666666;
        transition: .35s;
    }
    .def-col-stpromocao{
        width: 80px !important;
    }
    .tbprod{
        padding-left: 5px;
        padding-right: 5px;
    }
    .def-col-stpromocao{
        max-width: 100px !important;
    }
    .modal-produtos .modal-content {
        border-radius: 12px;
        padding: 0;
    }
    /* .modal-produtos .modal-header-custom {
        background: linear-gradient(45deg, #253544 , #1e2b37 );
        color: white;
    } */
</style>